import { useCustomSettingFlag } from '@hooks/useCustomSettingFlag';
import { Navigate } from 'react-router';
import { CustomSettingGuardProps } from './types';

export const CustomSettingGuard = ({
  children,
  disabledBy,
  redirectTo,
}: CustomSettingGuardProps) => {
  const disabled = useCustomSettingFlag(disabledBy);

  if (disabled) return <Navigate to={redirectTo} relative="path" replace />;
  return children;
};
